import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import classnames from 'classnames'
import styled from 'styled-components'
import shortid from 'shortid'
import {
  CustomInput,
  Form,
  FormGroup,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
} from 'reactstrap'
import moment from '../../lib/moment.js'

import { status, url } from '../../constants'

class PublicHolidayForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: '1',
    }
  }
  render() {
    return (
      /* eslint no-underscore-dangle: 0 */
      <Background>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={ classnames({ active: this.state.activeTab === '1' }) }
              onClick={ () => {} }
            >
              Holiday Information
            </NavLink>
          </NavItem>
          <Image
            src={ url }
            onClick={ get(this.props, 'create') ? this.props.cancelForm : this.props.showDiscard }
          />
        </Nav>
        <TabContent activeTab={ this.state.activeTab } >
          <TabPane tabId="1">
            <Row>
              <Col sm="12">
                <Form onSubmit={ (e) => e.preventDefault() }>
                  <FormGroup>
                    <Container >
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Holiday Name</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="description"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            placeholder="Enter Holiday Name"
                            value={ get(this.props, 'description') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Date</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputFieldDate
                            autoComplete='off'
                            name="date"
                            type="date"
                            disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                            value={ moment(get(this.props, 'date')).format('YYYY-MM-DD') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      {
                        get(this.props, 'create') === undefined &&
                        <Row style={ { marginTop: 10 } }>
                          <Col sm={ 3 }><Label>Status</Label></Col>
                          <Col sm={ 9 }>
                            <CustomInputField
                              type="select"
                              id="is_active"
                              name="is_active"
                              disabled={ !get(this.props, 'isEdit') && get(this.props, 'create') === undefined }
                              value={ get(this.props, 'is_active') }
                              onChange={ this.props.handleInput }
                            >
                              {
                                status.map((s) => <option key={ shortid() } value={ s.value }>{ s.label }</option>)
                              }
                            </CustomInputField>
                          </Col>
                        </Row>
                      }
                      {
                        get(this.props, 'create') === undefined &&
                          <Row style={ { marginTop: 10 } }>
                            <Col sm={ 3 }><Label>Modified Date</Label></Col>
                            <Col sm={ 9 }>
                              <p>{ get(this.props, 'updated') ? moment(get(this.props, 'updated')).format('DD/MM/YYYY') : '-' }</p>
                            </Col>
                          </Row>
                      }
                      {
                        get(this.props, 'create') === undefined &&
                          <Row style={ { marginTop: 10 } }>
                            <Col sm={ 3 }><Label>Modified By</Label></Col>
                            <Col sm={ 9 }>
                              <p>{ get(this.props, 'updated_by') ? get(this.props, 'updated_by') : '-' }</p>
                            </Col>
                          </Row>
                      }
                    </Container>
                  </FormGroup>
                  <Right>
                    { get(this.props, 'button') }
                  </Right>
                </Form>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </Background>
    )
  }
}

PublicHolidayForm.propTypes = {
  handleInput: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
}

export default PublicHolidayForm

const Right = styled.div`
  background-color: white;
  padding: 10px;
  text-align: right;
`

const Background = styled.div`
  background-color: white;
  padding: 10px;
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
`
const InputField = styled(Input)`
  font-family: 'Gotham' !important;
  width : 100% ;
  height : 100% ;
  font-size: 12px ;
`
const InputFieldDate = styled(Input)`
  font-family: 'Gotham' !important;
  width : 100% ;
  height : 100% ;
  font-size: 12px ;
  float: right;
  ::-webkit-inner-spin-button {
    display: none;
    -webkit-appearance: none;
  }
`
const Image = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
  right: 10px;
`
const CustomInputField = styled(CustomInput)`
  font-family: 'Gotham' !important;
  width : 100% ;
  height : 100% ;
  font-size: 12px ;
`




// WEBPACK FOOTER //
// ./src/components/public-holiday/index.js